/// <reference types="vite/client" />

import devConfig from './development.json';
import prodConfig from './production.json';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface WebConfig {
  sentry: {
    dsn: string;
  };
  launchDarkly: {
    clientId: string;
  };
  mixpanel: {
    token: string;
  };
  trello: {
    apiKey: string;
  };
  canny: {
    appId: string;
  };
}

// ---------------------------------------------------------------------------
// Deep merge — override values take precedence over base
// ---------------------------------------------------------------------------

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function deepMerge(base: any, override: any): any {
  const result = { ...base };

  for (const key in override) {
    const overrideVal = override[key];
    const baseVal = base[key];

    if (
      overrideVal !== undefined &&
      overrideVal !== null &&
      typeof overrideVal === 'object' &&
      !Array.isArray(overrideVal) &&
      typeof baseVal === 'object' &&
      baseVal !== null &&
      !Array.isArray(baseVal)
    ) {
      result[key] = deepMerge(baseVal, overrideVal);
    } else if (overrideVal !== undefined) {
      result[key] = overrideVal;
    }
  }

  return result;
}

// ---------------------------------------------------------------------------
// Config — VITE_CONFIG (optional) should contain the full config JSON as a
// string; when set its values override the base file config.
// ---------------------------------------------------------------------------

const baseConfig = import.meta.env.PROD ? prodConfig : devConfig;

let envOverride: Partial<WebConfig> = {};

const viteConfig = import.meta.env.VITE_CONFIG;
if (viteConfig) {
  try {
    envOverride = JSON.parse(viteConfig) as Partial<WebConfig>;
  } catch (err) {
    console.error('[config] Failed to parse VITE_CONFIG:', err);
  }
}

export const config: WebConfig = deepMerge(baseConfig, envOverride);
